import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionResultWeDeliver = () => {
  const { t } = useTranslation();
  return (
    <section className="result-we-deliver">
      <div className="title-section">
        <p className="title">{t('The Result We Deliver')}</p>
        <span className="tag">(04)</span>
      </div>
      <div className="video">
        <video src="/video/video-result-we-deliver.mp4"></video>
      </div>
      <div className="box-info">
        <div className="columns">
          <div className="item">
            <p className="percent">250%</p>
            <p className="desc">
              {t('Improvement in operational efficiency with customized AI trading system')}
            </p>
          </div>
          <div className="item">
            <p className="percent">500%</p>
            <p className="desc">
              {t(
                'Increase in monthly transaction volume and over 100,000 active users secured through custom NFT trading platform development'
              )}
            </p>
          </div>
        </div>
        <div className="columns">
          <div className="item">
            <p className="percent">120%</p>
            <p className="desc">
              {t('Increase in customer conversion rate with customized web/mobile applications')}
            </p>
          </div>
          <div className="item">
            <p className="percent">80%</p>
            <p className="desc">
              {t('Improvement in learning engagement with AI-based learning management system')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(SectionResultWeDeliver);
